import { useAuthStore } from '../store/authStore.js';

const PERMISSIONS = {
  ADMIN: ['view_messages', 'send_messages', 'delete_messages', 'create_contacts', 'import_contacts', 'export_data', 'manage_users', 'assign_contacts'],
  MANAGER: ['view_messages', 'send_messages', 'create_contacts', 'import_contacts', 'export_data', 'assign_contacts'],
  AGENT: ['view_messages', 'send_messages'],
};

export function usePermission() {
  const user = useAuthStore((s) => s.user);
  const role = user?.role || 'AGENT';

  return {
    can: (permission) => PERMISSIONS[role]?.includes(permission) || false,
    role,
    isAdmin: role === 'ADMIN',
    isManager: role === 'MANAGER',
    isAgent: role === 'AGENT',
  };
}
